import PoiPanel from "./PoiPanel";

// "Entdecken Mönchgut" — POIs filtered by category
const poiModule = {
  // only used if the DB topic list fails or hasn't loaded yet
  fallbackLabel: "POI",
  Panel: PoiPanel,
};

export default poiModule;
